<template>
    <div class="collabsable-section model-uploads-section">
        <div class="section-title clickable-header" @click="toggleExpanded()">
            <div class="model-3d"></div>
            <div style="flex-grow: 1;font-size: 17px;">General Settings</div>
            <div style="color: gray;"
                :class="['expand-collapse-ico', 'fas', !isExpanded ? 'fa-caret-down' : 'fa-caret-up']">
            </div>
        </div>
        <div v-if="isExpanded" class="expanded-section">
            <div class="row-input">
                <div style="width: 250px;">Small Model upload limit</div>
                <input type="number" v-virtual-keyboard name="modelUploadLimit" v-model="modelUploadLimit"
                    style="width: 30%;margin-right: 100px;" placeholder="Model Upload Limit" />
                <div :class="{ 'disabled': disableSave }" class="admin-btn" @click="saveModelUploadLimitsDb()">Save</div>
            </div>
            <div class="row-input">
            <div style="width: 250px;">Active A-MIS</div>
                <CustomCheckbox :is_checked="forgeSettings.isAMIS" :name="'isAMIS'" @check_changed="toggleIsAMIS($event)"></CustomCheckbox>
            </div>
            <div class="row-input">
                <div style="width: 250px;;">ShareFile Path</div>
                <div style="width: 30%;margin-right: 100px;">{{shareFilePath}}</div>
                <div class="admin-btn" @click="editShareFilePath()">Edit</div>
            </div>
        </div>
    </div>
</template>

<script>
import { toggleExpandComponent } from '@/scripts/js/forgeviewer';
import { postDataAsync } from '@/utils/mongoUtils';
import HttpService from '../../../utils/httpService';
export default {
    name: 'AdminGeneralSettings',
    components: {
        CustomCheckbox: () => import('@/components/common/customCheckbox.vue'),
    },
    data() {
        return {
            isExpanded: false,
            modelUploadLimit: 0,
        }
    },
    methods: {
        toggleExpanded() {
            toggleExpandComponent(this);
        },
        editShareFilePath(){
            this.$store.state.shareFilePopupInfo.id = this.$store.state.forgeSettings.shareFileParentId;
            this.$store.state.shareFilePopupInfo.shown = true;
        },
        saveModelUploadLimitsDb() {
            HttpService.post({
                url: 'api/forge/settings/updateModelUploadLimit',
                data: { assetId: this.$store.state.assetId, modelUploadLimit: this.modelUploadLimit },
            }).then(() => {
                this.$store.state.forgeSettings.modelUploadLimit = this.modelUploadLimit;
            }).catch(() => {
                this.modelUploadLimit = this.$store.state.forgeSettings.modelUploadLimit;
                this.$store.dispatch("alert_Forge", {
                    message: 'Invalid value'
                })
            });
        },
        toggleIsAMIS ($event) {
            this.forgeSettings.isAMIS=$event.value;
            postDataAsync('api/forge/settings/updateIsAMISOn', { 'assetId': this.$store.state.assetId, 'IsAMIS': this.forgeSettings.isAMIS });
        }
    },
    mounted() {
        if (this.forgeSettings && this.forgeSettings.modelUploadLimit) {
            this.modelUploadLimit = this.forgeSettings.modelUploadLimit;
        } else {
            this.modelUploadLimit = 0;
        }
    },
    computed: {
        forgeSettings(){
            return this.$store.state.forgeSettings
        },
        disableSave: function () {
            return isNaN(this.modelUploadLimit) || this.modelUploadLimit == '' || this.modelUploadLimit < 0 || (this.$store.state.forgeSettings.modelUploadLimit == this.modelUploadLimit)
        },
        localModelUploadLimit: function () {
            return this.$store.state.forgeSettings.modelUploadLimit
        },
        shareFilePath(){
            return this.forgeSettings.shareFileParentId
        }
    },
    watch: {
        "forgeSettings": {
            handler:
                function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        this.modelUploadLimit = newValue.modelUploadLimit
                    }
                },
            deep: true
        }
    },
}
</script>

<style>
.model-uploads-section .row-input {
    justify-content: flex-start;
    padding: 10px 40px;
}

.model-uploads-section input {
    height: 30px;
}

.model-uploads-section .admin-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 0px;
    width: 200px;
    height: 20px;
}

.admin-btn.disabled {
    background: var(--light-primary-color);
    pointer-events: none;
}

.model-uploads-section input::-webkit-outer-spin-button,
.model-uploads-section input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>
